var siteHeader;
var stickyHeader;
var isSticky = false;
window.addEventListener('load',function(){
  siteHeader = document.querySelector('#shopify-section-header');
  stickyHeader = document.querySelector('#shopify-section-header .header--root');
  isSticky = (window.matchMedia && window.matchMedia('(max-device-width: 767px)').matches);
    
    stickyHeaderInit();
    window.addEventListener('scroll',function(){
      if (isSticky) {
         if (window.scrollY > 250) {
           stickyHeader.classList.add('site-header--stuck');
              setTimeout(function() {
                stickyHeader.classList.add('site-header--opening');
              }, 100);
         } else {
              stickyHeader.classList.remove('site-header--stuck');
              stickyHeader.classList.remove('site-header--opening');
         }
      } else {
          stickyHeader.classList.remove('site-header--stuck');
          stickyHeader.classList.remove('site-header--opening');
      }
    });
    
    window.addEventListener('resize',function(){
      isSticky = (window.matchMedia && window.matchMedia('(max-device-width: 767px)').matches);
      stickyHeaderHeight();
      setTimeout(function() {
        stickyHeaderHeight();
      }, 100);
    });
  
});


function stickyHeaderInit() {
  stickyHeaderHeight();
  if (Shopify && Shopify.designMode) {
    setTimeout(function() {
      stickyHeaderHeight();
    }, 250);
  }
}

function stickyHeaderHeight() {
    var h = stickyHeader.offsetHeight;
    siteHeader.style.height = h + 'px';
}